class LgTabs extends HTMLElement {
    constructor () {
      super();

      this.tabLinks = this.querySelectorAll('[data-target]');
      this.tabPanels = this.querySelectorAll('[data-tab]');
      this.focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    }

    connectedCallback () {
      this.tabLinks.forEach(tab => tab.addEventListener('click', this.handleTab.bind(this)));
      this._setPanelTabindex();
    }

    _setPanelTabindex () {
      this.tabPanels.forEach(panel => {
        var isHidden = !panel.classList.contains('show');
        panel.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
        var focusables = panel.querySelectorAll(this.focusableSelector);
        focusables.forEach(el => {
          if (isHidden) {
            if (el.getAttribute('tabindex') !== null) el.setAttribute('data-lg-tabindex-store', el.getAttribute('tabindex'));
            el.setAttribute('tabindex', '-1');
          } else {
            if (el.hasAttribute('data-lg-tabindex-store')) {
              var s = el.getAttribute('data-lg-tabindex-store');
              if (s === '' || s === '0') el.removeAttribute('tabindex');
              else el.setAttribute('tabindex', s);
              el.removeAttribute('data-lg-tabindex-store');
            }
          }
        });
      });
    }

    handleTab (e) {
      const { target } = e.target.dataset;

      this.tabLinks.forEach(tab => {
        if (tab.dataset.target === target) {
          tab.closest('.tab-item').classList.add('active');
          tab.setAttribute('aria-selected', 'true');
        } else {
          tab.closest('.tab-item').classList.remove('active');
          tab.setAttribute('aria-selected', 'false');
        }
      });

      this.tabPanels.forEach(panel => {
        if (panel.dataset.tab === target) {
          panel.classList.add('show');
          panel.setAttribute('aria-hidden', 'false');
          var focusables = panel.querySelectorAll(this.focusableSelector);
          focusables.forEach(el => {
            if (el.hasAttribute('data-lg-tabindex-store')) {
              var s = el.getAttribute('data-lg-tabindex-store');
              if (s === '' || s === '0') el.removeAttribute('tabindex');
              else el.setAttribute('tabindex', s);
              el.removeAttribute('data-lg-tabindex-store');
            }
          });
          setTimeout(() => panel.classList.add('active'), 0);
        } else {
          panel.classList.remove('active');
          panel.setAttribute('aria-hidden', 'true');
          var focusables = panel.querySelectorAll(this.focusableSelector);
          focusables.forEach(el => {
            if (el.getAttribute('tabindex') !== null) el.setAttribute('data-lg-tabindex-store', el.getAttribute('tabindex'));
            el.setAttribute('tabindex', '-1');
          });
          setTimeout(() => panel.classList.remove('show'), 0);
        }
      });
    }
  }

  customElements.define('lg-tabs', LgTabs)